import { useEffect, useState } from "react";
import { FounderStoryEvent, subscribeFounderStoryTimeline } from "../services/founderStoryService";

type FounderStoryState = {
  events: FounderStoryEvent[];
  error: string | null;
  isLoading: boolean;
  lastUpdated: Date | null;
};

export function useFounderStory(): FounderStoryState {
  const [events, setEvents] = useState<FounderStoryEvent[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeFounderStoryTimeline(
      (timeline) => {
        setEvents(timeline.events);
        setLastUpdated(timeline.lastUpdated);
        setError(null);
        setIsLoading(false);
      },
      () => {
        setError("Unable to load Founder Story.");
        setIsLoading(false);
        setLastUpdated(new Date());
      }
    );

    return unsubscribe;
  }, []);

  return {
    events,
    error,
    isLoading,
    lastUpdated
  };
}
